import { Injectable } from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError, delay, finalize, map} from 'rxjs/operators';

import {HISTORY_KEY_VIEW_PROVERB, SearchParam} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, PAGE, PROVERB_IN2_API_URL} from '../../defines/protocol';
import {PROVERB_PAGE_SIZE} from '../../defines/desktop.const';
import {Proverb} from '../../models/proverb.model';
import {SearchHistory} from '../../models/history.model';
import {ApiService} from '../api/api.service';
import {ProverbService} from './proverb.service';

@Injectable({
  providedIn: 'root'
})
export class ProverbHistoryService extends ProverbService {
  private history: SearchHistory;


  constructor(
    protected override api: ApiService,
  ) {
    super(api);

    this.urlApi = PROVERB_IN2_API_URL;
    this.history = new SearchHistory({name: HISTORY_KEY_VIEW_PROVERB});
  }

  public addHistory(id: string): void {
    if (!id) {
      console.error('ProverbHistoryService::addHistory() invalid id', id);
    }
    else {
      this.history.addItem(id);
    }
  }

  /******************************************************************************
   * ListLoader<SimpleProverb> 구현부
   *****************************************************************************/


  public override ResetList(param?: SearchParam): Observable<number> {
    // console.log('ProverbHistoryService::ResetList()', param, this);

    if (param?.id) {
      this.addHistory(param.id);
    }
    return super.ResetList(param);
  }

  protected override getUrlList(url: string): Observable<Array<Proverb>> {
    if (this.load$) {
      return this.load$;
    }
    else if (this.history?.empty()) {
      // 이력이 없으면 서버에 요청하지 않고 처리한다.
      return new Observable<Array<Proverb>>(observer => {
        observer.next(new Array<Proverb>());
        observer.complete();
      }).pipe(delay(0));
    }

    if (this.load$) {
      return this.load$;
    }

    return this.load$ = this.api.Post(url,
      {list: this.history.list}, {page_size: PROVERB_PAGE_SIZE}, CONTENT_TYPE_JSON_UTF8).pipe(
      catchError(err => {
        if (err?.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      } ),
      map((data: PAGE) => {
        console.log('ProverbService::getUrlList.api.Get data =', data);

        if (this.totalCount === null) {
          this.totalCount = data.count;
        }
        else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data );
        }

        this.listProverb = new Array<Proverb>();
        this.mapProverb = new Map<string, Proverb>();

        data.results.forEach(value => {
          const proverb = new Proverb(value);
          this.listProverb?.push(proverb);
          this.mapProverb?.set(proverb.id, proverb);
        });

        this.nextUrl = data.next ?? null;
        this.prevUrl = data.previous ?? null;

        if (this.totalCount !== this.history.size) {
          console.error('ProverbHistoryService::getUrlList() invalid received list size',
            this.totalCount, this.history.list);
        }

        return this.listProverb;
      })
    );
  }

}
